import React, { useState } from "react";
import { RingLoader } from "react-spinners";
import AVReactPlayer from "./AVReactPlayer";
import Slider from "react-slider";
import styled from "styled-components";
import Switch from "react-switch";

const StyledThumb = styled.div`
    height: 60px;
    width: 9px;
    background: linear-gradient(to right, #bbb, #777);
    cursor: grab;
    border-radius: 25px;
    border: 2px solid #ccc;
`;

const StyledTrack = styled.div`
    top: 10px;
    bottom: 0;
    border-radius: 10px;
    background: linear-gradient(
        to right,
        #0fa ${(props) => (props.index === 1 ? "0%" : "100%")},
        #ddd ${(props) => (props.index === 1 ? "0%" : "100%")}
    );
`;

const Track = ({ index, switchValue, ...props }) => (
    <StyledTrack {...props} index={index} switchValue={switchValue} />
);

const StyledSlider = styled(Slider)`
    width: 100%;
    height: 50px;
`;

const Thumb = (props, state) => <StyledThumb {...props} />;

const Container = styled.div`
    /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em; // Измените размер шрифта для увеличения кнопки
    padding: 10px 20px; // Увеличьте отступы для увеличения кнопки
    border-radius: 5px;
    font-weight: bold;
`;

const StyledLabel = styled.label`
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
`;

const StyledRadio = styled.input`
    margin-right: 8px;
    transform: scale(2);
`;

const StyledDiv = styled.div`
    position: relative;
    width: 260px;
    height: 260px;
    background-color: #fff;
    border: 1px solid #000;
    margin: 0 auto;
    overflow: hidden; /* Add overflow: hidden to clip content */
`;

const ProportionalRectangle = styled.div`
    position: absolute;
    width: ${(props) => props.width - 20}px;
    height: ${(props) => props.height - 20}px;
    background-color: #ccc;
    border: 1px solid #000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(${(props) => props.rotation}deg);
    margin: 5px; /* Set equal margins on all sides */
    padding: 5px; /* Add padding to maintain the size of the rectangle */

    display: flex;
    justify-content: center;
    align-items: center;
`;

const Half = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Letter = styled.div`
    font-size: 24px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; // Use the full height of the viewport
    width: 100%; // Use the full width
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const VRotateSlider = (props) => {
    const {
        titleDownload,
        titleDelete,
        titleRotateAnotherVideo,
        titleRotate,
        titleFlip,
        titleFlop,
        titleAngelOfRotation,
        titleReady,
        titleCurrentFile,
        tip1,
        titleReversePlayback,
    } = props.attributes;

    const [isLoading, setIsLoading] = useState(false);
    const [fileId, setfileId] = useState(props.fileId);
    const [fileName, setfileName] = useState(props.fileName);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [flip, setFlip] = useState(false);
    const [flop, setFlop] = useState(false);
    const [reversePlayback, setReversePlayback] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showPlayer, setShowPlayer] = useState(true);

    /* const handleSliderChange = (value) => {
        setRotation(value);
        setFlip(false);
        setFlop(false);
    }; */

    const handleSliderChange = (value) => {
        setRotation(value * 90); // Умножьте значение слайдера на 90, чтобы получить угол поворота
        setFlip(false);
        setFlop(false);
    };

    /* console.log(props.videoWidthExt);
    console.log(props.videoHeightExt); */

    const containerSize = 200; // Size of the container square

    // Calculate the size of the proportional rectangle based on the video dimensions
    const { videoWidthExt, videoHeightExt } = props;
    let rectangleWidth, rectangleHeight;

    if (videoWidthExt > videoHeightExt) {
        rectangleWidth = containerSize;
        rectangleHeight = (videoHeightExt / videoWidthExt) * containerSize;
    } else {
        rectangleWidth = (videoWidthExt / videoHeightExt) * containerSize;
        rectangleHeight = containerSize;
    }

    const handleOptionChange = (option) => {
        if (option === "flip") {
            setFlip(true);
            setFlop(false);
            setReversePlayback(false);
            setRotation(0); // Сброс значения слайдера при выборе опции flip
        } else if (option === "flop") {
            setFlop(true);
            setFlip(false);
            setReversePlayback(false);
            setRotation(0); // Сброс значения слайдера при выборе опции flop
        } else if (option === "reversePlayback") {
            setFlop(false);
            setFlip(false);
            setReversePlayback(true);
            setRotation(0); // Сброс значения слайдера при выборе опции flop
        } else {
            setFlip(false);
            setFlop(false);
            setReversePlayback(false);
        }
    };

    const handleRotate = async (e) => {
        e.preventDefault();
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowPlayer(false);

        const requestBody = {
            fileid: props.fileId,
            rotation: rotation,
            flip: flip,
            flop: flop,
            reversePlayback: reversePlayback,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/rotateVideo?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowPlayer(true);
        props.setShowUploader(true);
    };

    function getFileName(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }

    const reloadPage = () => {
        setShowPlayer(true);
        location.reload();
    };

    return (
        <Container>
            {showPlayer && (
                <div className="vrotate-slider">
                    {/* {props.videoUrl && (
                <AVReactPlayer
                    videoUrl={props.videoUrl}
                />
            )} */}
                    <StyledDiv>
                        <ProportionalRectangle
                            width={rectangleWidth}
                            height={rectangleHeight}
                            rotation={rotation}
                        >
                            <Half>
                                <Letter>A</Letter>
                            </Half>
                            <Half>
                                <Letter>B</Letter>
                            </Half>
                        </ProportionalRectangle>
                    </StyledDiv>
                    <div className="px-4 py-2">
                        <div>
                            {titleCurrentFile}: {props.fileName}
                        </div>
                        <div className="slider-container">
                            {titleAngelOfRotation}
                            {/* <StyledSlider
                                min={0}
                                max={360}
                                value={rotation}
                                onChange={handleSliderChange}
                                className="slider"
                                renderTrack={(props, state) => (
                                    <Track {...props} index={state.index} switchValue={props.switchValue} />
                                )}
                                renderThumb={Thumb}
                            /> */}
                            <StyledSlider
                                min={0}
                                max={3}
                                step={1}
                                value={rotation / 90} // Переведите угол поворота обратно в значение слайдера, поделив его на 90
                                onChange={handleSliderChange}
                                className="slider"
                                renderTrack={(props, state) => (
                                    <Track
                                        {...props}
                                        index={state.index}
                                        switchValue={props.switchValue}
                                    />
                                )}
                                renderThumb={Thumb}
                            />
                            <div className="slider-value pt-2">{rotation}°</div>
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <div className="options-container">
                            <StyledLabel>
                                <Switch
                                    checked={flip}
                                    onChange={() => handleOptionChange("flip")}
                                    onColor="#48BB78"
                                    onHandleColor="#ffffff"
                                    offColor="#ccc"
                                    offHandleColor="#ffffff"
                                    handleDiameter={20}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                                <div className="pl-2">{titleFlip}</div>
                            </StyledLabel>
                            <StyledLabel>
                                <Switch
                                    checked={flop}
                                    onChange={() => handleOptionChange("flop")}
                                    onColor="#48BB78"
                                    onHandleColor="#ffffff"
                                    offColor="#ccc"
                                    offHandleColor="#ffffff"
                                    handleDiameter={20}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                                <div className="pl-2">{titleFlop}</div>
                            </StyledLabel>
                            <StyledLabel>
                                <Switch
                                    checked={reversePlayback}
                                    onChange={() =>
                                        handleOptionChange("reversePlayback")
                                    }
                                    onColor="#48BB78"
                                    onHandleColor="#ffffff"
                                    offColor="#ccc"
                                    offHandleColor="#ffffff"
                                    handleDiameter={20}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                                <div className="pl-2">
                                    {titleReversePlayback}
                                </div>
                            </StyledLabel>
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={handleRotate}>
                                {titleRotate}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleRotateAnotherVideo}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>
                    <div className="px-4 py-2">
                        <AVReactPlayer videoUrl={downloadUrl} />
                    </div>
                    <ButtonContainer>
                        <a
                            href={downloadUrl}
                            download={getFileName(downloadUrl)}
                            onClick={handleDownload}
                        >
                            <StyledButton>{titleDownload}</StyledButton>
                        </a>
                        <a className="pl-2" onClick={handleDownload}>
                            <StyledButtonDelete>
                                {titleDelete}
                            </StyledButtonDelete>
                        </a>
                    </ButtonContainer>
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleRotateAnotherVideo}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default VRotateSlider;
